import React from 'react';
import { connect } from 'react-redux';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
import { match } from 'react-router-dom';

// Components
import App from '../../../components/app';
import ErrorMessage from '../../../components/error-message';
import EnhancedForm from '../../../components/form';
import { FormDatas, FormPickerDatas } from '../../../local-types';
// Modules
import { actions as companyActions, types as companyTypes } from '../../../redux/reducers/companies';
import { selectors as pendingSelectors } from '../../../redux/reducers/pendingOperations';
import { selectors as errorSelectors, ErrorPayload } from '../../../redux/reducers/errors';
// ressources
import ObjectUtils from '../../../utils/objectUtils';
import styles from './company-contract-add-style';
import { AccountRight, RightRank } from '../../../utils/userUtils';
import { paths } from '../../paths';
import { TParams } from '../../../redux/reducers/api-types';

interface CompanyAddProps extends WithTranslation, WithStyles {
    match: match<TParams>;
    saveContract: (id: string, payload) => any;
    companiesSaveContractError: ErrorPayload;
    isSavingContract: boolean;
}

interface State {
    formData: any;
}

class CompanyAddContractPage extends React.Component<CompanyAddProps, State> {
    inputs: FormDatas[];
    status: FormPickerDatas[];

    constructor(props: CompanyAddProps) {
        super(props);
        const { t, match } = props;
        const id = match.params.id;
        this.state = {
            formData: {
                document_class: 'company',
                file: '',
                company_id: id,
                document_type: 'contract',
                version: {
                    snapcar_ref: '',
                    external_ref: '',
                    state: '',
                    start_date: '',
                    end_date: '',
                },
            },
        };
        this.status = [
            { id: 'created', name: t('document:status.created') },
            { id: 'signing', name: t('document:status.signing') },
            { id: 'pending', name: t('document:status.pending') },
            { id: 'active', name: t('document:status.active') },
            { id: 'terminated', name: t('document:status.terminated') },
        ];

        this.inputs = [
            {
                title: t('add_contract.title'),
                datas: [
                    {
                        id: 'file',
                        label: t('add_contract.file'),
                        type: 'file',
                        required: true,
                    },
                    { id: 'version[snapcar_ref]', label: t('add_contract.snapcar_ref') },
                    {
                        id: 'version[external_ref]',
                        label: t('add_contract.external_ref'),
                    },
                    {
                        id: 'version[start_date]',
                        label: t('add_contract.start_date'),
                        type: 'date',
                    },
                    {
                        id: 'version[end_date]',
                        label: t('add_contract.end_date'),
                        type: 'date',
                    },
                    {
                        id: 'version[state]',
                        label: t('add_contract.state'),
                        options: this.status,
                        required: true,
                    },
                ],
            },
        ];
    }

    inputsBuilder = () => {};

    onSubmit = (formData, event, stringify, keepFormData): void => {
        const { saveContract, match } = this.props;
        const id = match.params.id;
        const data = stringify;

        const cleanFormData = ObjectUtils.deepCopy(formData.version);
        Object.keys(cleanFormData).forEach((key) => {
            if (cleanFormData[key] == null || cleanFormData[key] === '') {
                delete cleanFormData[key];
            }
        });

        data.set('version', JSON.stringify(cleanFormData));
        data.append('document_class', 'company');
        data.append('company_id', match.params.id);
        data.append('document_type', 'contract');
        this.setState({
            formData: keepFormData,
        });
        saveContract(id, data);
    };

    render() {
        const { match, companiesSaveContractError, isSavingContract } = this.props;
        const id = match.params.id;

        const formPayload = this.state.formData;

        return (
            <App needRights={{ name: AccountRight.COMPANY_SETTINGS, mode: RightRank.W }}>
                <ErrorMessage payload={companiesSaveContractError} />
                {this.inputs && (
                    <>
                        <EnhancedForm
                            payload={formPayload}
                            inputs={this.inputs}
                            backRoute={`${paths.companies}/${id}`}
                            onSubmit={this.onSubmit}
                            loader={isSavingContract}
                        />
                    </>
                )}
            </App>
        );
    }
}

const CompanyAddContractPageWithStyleAndTranslation = withStyles(styles)(
    withTranslation(['company', 'document', 'common'])(CompanyAddContractPage),
);

const mapStateToProps = (state) => ({
    companiesSaveContractError: errorSelectors.getSaveCompanyContractError(state),
    isSavingContract: pendingSelectors.isPending(state, companyTypes.SAVE_COMPANY_CONTRACT),
});

const mapDispatchToProps = {
    saveContract: companyActions.saveContract,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyAddContractPageWithStyleAndTranslation);
